import API from 'services/api.services';
import {
	setQueue,
	advanceQueue,
	setErrorKey,
} from 'state/reducers/system-messages.reducer';
import {
	API_SYSTEM_MESSAGES_PENDING,
	API_SYSTEM_MESSAGES_CONFIRM,
} from 'constants/db.constants';

let isFetchingPending = false;

export const fetchPendingSystemMessages = () => async (dispatch: any) => {
	if (isFetchingPending) {
		return;
	}
	isFetchingPending = true;
	try {
		const response = await API.getInstance().get(API_SYSTEM_MESSAGES_PENDING);
		const data = response.data?.data;
		dispatch(setQueue(Array.isArray(data) ? data : []));
	} catch (_error: any) {
		// Deliberate silent failure — backend hiccup at login must not block the app.
	} finally {
		isFetchingPending = false;
	}
};

export const confirmSystemMessage = (systemMessageId: number) => async (dispatch: any) => {
	try {
		await API.getInstance().post(API_SYSTEM_MESSAGES_CONFIRM, {
			systemMessageId,
		});
		dispatch(setErrorKey(null));
		dispatch(advanceQueue());
	} catch (error: any) {
		const statusCode = error?.statusCode;
		if (statusCode === 404) {
			dispatch(setErrorKey(null));
			dispatch(advanceQueue());
		} else {
			dispatch(setErrorKey('portal.systemMessage.errors.failed'));
			dispatch(advanceQueue());
		}
	}
};
